import { Routes } from '@angular/router';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';

export const VERIFY_EMAIL_ROUTES: Routes = [
    {
        path: 'verify-email',
        component: VerifyEmailComponent,
    },
];
